enum QuestionType {
    ACTIVITY = 'activity',
    INDICATOR = 'indicator',
  }

export default QuestionType;
